import PropTypes from "prop-types";
import React from "react";
import shallowequal from "shallowequal";

export default class DataFetcher extends React.Component {
    static propTypes = {
        getQuery: PropTypes.func.isRequired,
        Component: PropTypes.func.isRequired,
        shouldRefetch: PropTypes.func,
        mapQueryStateToProps: PropTypes.func,
        proxiedProps: PropTypes.object
    };
    static defaultProps = {
        shouldRefetch: shallowequal,
        mapQueryStateToProps: state => state,
        proxiedProps: {}
    };
    state = {
        fetching: false,
        data: null,
        error: null
    };
    componentWillMount() {
        this.fetchData(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (
            nextProps.shouldRefetch(
                this.props.proxiedProps,
                nextProps.proxiedProps
            )
        ) {
            this.fetchData(nextProps);
        }
    }
    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }
    handleSnapshot = documentOrQuerySnapshot => {
        const data = Array.isArray(documentOrQuerySnapshot.docs)
            ? documentOrQuerySnapshot.docs.map(doc => doc.data())
            : documentOrQuerySnapshot.data();
        this.setState({ fetching: false, data: data, error: null });
    };
    handleError = err => {
        this.setState({ fetching: false, data: null, error: err });
    };
    fetchData(props) {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        this.setState({ fetching: true });
        this.unsubscribe = props
            .getQuery(props.proxiedProps)
            .onSnapshot(this.handleSnapshot, this.handleError);
    }
    render() {
        return (
            <this.props.Component
                {...this.props.proxiedProps}
                {...this.props.mapQueryStateToProps(this.state)}
                refetch={() => this.fetchData(this.props)}
            />
        );
    }
}

export const withData = options => Component => proxiedProps => (
    <DataFetcher
        getQuery={options.getQuery}
        Component={Component}
        mapQueryStateToProps={options.mapQueryStateToProps}
        shouldRefetch={options.shouldRefetch}
        proxiedProps={proxiedProps}
    />
);



// WEBPACK FOOTER //
// ./src/components/DataFetcher/index.js